// В.2.e-2: Главная Лаборатория (liv_glavnaya_laboratoriya, epic, 0/1/7).
// Триггер «в конце хода»: воскрешает случайного юнита из своего сброса.
// Лимит: 3 использования; после 3-го — Лаборатория сама уходит в сброс.
//
// Реализация:
//   - Счётчик использований в card.labResurrectionsLeft (init=3 при появлении
//     на поле через registerUnitSummonedExtraHandler — НЕ перезаписывается,
//     если уже инициализирован).
//   - В EOT (через registerOnEndOfTurnTrigger):
//     · Если labResurrectionsLeft <= 0 → ничего (карта уже должна была
//       уйти в сброс на прошлом тике, но защитная ветка).
//     · Если в сбросе нет юнитов или нет свободного слота на поле — пропуск,
//       счётчик НЕ тратится.
//     · Иначе: resurrectUnit случайного юнита из сброса, счётчик -1.
//     · Если после декремента счётчик === 0 → destroyUnit самой Лаборатории.
//   - Молчание Лаборатории блокирует триггер (через runOnEndOfTurnTriggers,
//     это уже в каркасе). Счётчик при этом не тратится.

import { registerOnEndOfTurnTrigger } from './eot-triggers.js';
import { registerUnitSummonedExtraHandler } from '../deus/hooks.js';
import { registerImplementedAbility } from './warn-unimplemented.js';
import { resurrectUnit } from './resurrect.js';
import { destroyUnit } from './destroy.js';

export const CARD_ID = 'liv_glavnaya_laboratoriya';
const LABEL = 'Главная Лаборатория';
const USES = 3;

registerImplementedAbility(CARD_ID, 'trigger');

// Инициализация счётчика при появлении на поле.
registerUnitSummonedExtraHandler((state, ownerIdx, card) => {
  if (!card || card.id !== CARD_ID) return;
  if (typeof card.labResurrectionsLeft === 'number') return;
  card.labResurrectionsLeft = USES;
});

registerOnEndOfTurnTrigger(CARD_ID, (state, lab) => {
  if (!lab || !lab.isAlive()) return;
  const ownerIdx = lab.ownerId;
  if (ownerIdx == null) return;
  const owner = state.players[ownerIdx];
  if (!owner) return;
  const left = lab.labResurrectionsLeft ?? USES;
  if (left <= 0) return;
  // Кандидаты — юниты в своём сбросе.
  const candidates = owner.discard.filter(c => c?.type === 'unit');
  if (candidates.length === 0) {
    state.log?.add(`🔁 ${LABEL} [${owner.name}]: в сбросе нет юнитов — пропуск (осталось ${left})`);
    return;
  }
  if (!owner.hasFreeSlot()) {
    state.log?.add(`🔁 ${LABEL} [${owner.name}]: нет свободной ячейки — пропуск (осталось ${left})`);
    return;
  }
  // Выбор случайного.
  const dead = candidates[state.rng.int(candidates.length)];
  const ok = resurrectUnit(state, dead, ownerIdx, null);
  if (!ok) {
    state.log?.add(`🔁 ${LABEL} [${owner.name}]: воскрешение не состоялось — пропуск`);
    return;
  }
  lab.labResurrectionsLeft = left - 1;
  state.log?.add(
    `🔁 ${LABEL} [${owner.name}]: воскрешение → ${dead.name_ru} (осталось ${lab.labResurrectionsLeft})`
  );
  // После 3-го использования — Лаборатория уходит в сброс.
  if (lab.labResurrectionsLeft <= 0) {
    state.log?.add(`✗ ${LABEL} [${owner.name}] уходит в сброс (лимит исчерпан)`);
    destroyUnit(state, lab, ownerIdx, null, null);
  }
});
